import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";

import jpActions from "../../../actions/jpActions";
import JPTheme from "../../../themes/JPTheme";
import Dashboard from "./Dashboard";
import JobPlan from "./JobPlan/JobPlan";
import JobPlanList from "./JobPlan/JobPlanList";
import JobPlanInsights from "./JobPlan/JobPlanInsights";

const routes = [
    { path: "/jp/jobplans/:id/insights", component: JobPlanInsights },
    { path: "/jp/jobplans/:id", component: JobPlan },
    { path: "/jp/jobplans", component: JobPlanList },
    { path: "/jp/", component: Dashboard },
];

const JPRouter = () => (
    <ThemeProvider theme={JPTheme}>
        <Switch>
            {routes.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    component={route.component}
                />
            ))}
        </Switch>
    </ThemeProvider>
);

const JPContainer = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(jpActions.getJobPlanActivityCategories("P-JP"));
        dispatch(jpActions.getJobPlanActivityTypes("P-JP"));
        dispatch(jpActions.getJobPlanActivityLocations("P-JP"));
    }, [dispatch]);

    return <JPRouter />;
};

export default JPContainer;
